import { SET_MESSAGGIO, RESET_MESSAGGIO, SET_SNACKBAR, RESET_SNACKBAR } from "./actionsType";

export const setMessaggioAction = (payload) => ({
    type: SET_MESSAGGIO,
    payload
})

export const resetMessaggioStateAction = () => ({
    type: RESET_MESSAGGIO
})

export const setSnackbarAction = (payload) => ({
    type: SET_SNACKBAR,
    payload
})

export const resetSnackbarStateAction = () => ({
    type: RESET_SNACKBAR
})
